import api from '../collums-components/api/config';
import axios from 'axios';
import imageCompression from 'browser-image-compression';

class TreatmentImagesApi {
    static getPresignedURI({ name, type = 'image/jpg' }) {
        return api.request({
            method: 'GET',
            url: `/treatment-images/upload-url?type=${type}&name=${name}`
        });
    }

    static createWithoutUrl(data) {
        return api.request({
            method: 'POST',
            url: '/treatment-images/without-url',
            data
        });
    }

    static finishUpload(id, data) {
        return api.request({
            method: 'PUT',
            url: `/treatment-images/finish-upload/${id}`,
            data
        });
    }

    static async uploadImage(file, name) {
        const fileType = file.type || 'image/jpeg';

        const recordId = await this.createWithoutUrl({
            name: name,
            type: fileType
        });

        const uploadData = await this.getPresignedURI({
            name: name,
            type: fileType
        });

        const signedRequest = uploadData.signedRequest;
        const url = uploadData.url;

        let optimizedFile;
        if (fileType !== 'application/pdf') {
            const optimizationOptions = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
                fileType: 'image/jpeg'
            };

            try {
                const optimizedImg = await imageCompression(file, optimizationOptions);
                optimizedFile = new File([optimizedImg], file.name, {
                    type: fileType
                });
            } catch (e) {
                console.error('Image compression error:', e);
                optimizedFile = file;
            }
        } else {
            optimizedFile = file;
        }

        const options = {
            headers: {
                'Content-Type': fileType,
                'x-amz-acl': 'public-read'
            }
        };

        try {
            await axios.put(signedRequest, optimizedFile, options);
        } catch (error) {
            console.error('Upload error:', error);
            throw error;
        }

        const finishedRecord = await this.finishUpload(recordId, { url });

        return finishedRecord;
    }

    static create(data) {
        return api.request({
            method: 'POST',
            url: '/treatment-images',
            data
        });
    }

    static list() {
        return api.request({
            method: 'GET',
            url: '/treatment-images'
        });
    }

    static delete(id) {
        return api.request({
            method: 'DELETE',
            url: `/treatment-images/${id}`
        });
    }

    static update(id, data) {
        return api.request({
            method: 'PUT',
            url: `/treatment-images/${id}`,
            data
        });
    }
}

export default TreatmentImagesApi;
